/*
 * Push notification endpoint.
 *
 * Route: dashboard -> be-admin -> be-notification (the same hop be-admin uses for be-customer)
 *   POST {REACT_APP_API_ADMIN_URL}/api/v1/admin-actions/push-notification/send
 * Auth is the admin's own access token (userid + x-id-token headers), like every other
 * admin-action. be-admin then forwards to http://notification:3000/api/v1/push/notification
 * service-to-service, without passing the x-id-token on, which is what lets a topic push
 * through: be-notification rejects topic targets whenever an end-user token is present
 * (B2CTH-3116), and the dashboard cannot reach that route directly at all.
 *
 * The body must match th-b2c-techupgrade-be-notification's model
 * (src/model/RequestBody/PushNotification.ts): both services validate with
 * whitelist + forbidNonWhitelisted, so any undeclared field comes back as a 400.
 */

const trim = value => (value || "").trim().replace(/\/+$/, "");

// be-admin's base URL; set REACT_APP_API_NOTIFICATION_URL to point somewhere else, e.g. a local service
export const PUSH_API_BASE =
  trim(process.env.REACT_APP_API_NOTIFICATION_URL) || trim(process.env.REACT_APP_API_ADMIN_URL);

// Path of the push notification POST
export const PUSH_SEND_PATH =
  (process.env.REACT_APP_API_PUSH_PATH || "/api/v1/admin-actions/push-notification/send").trim();

export const PUSH_SEND_URL = `${PUSH_API_BASE}${PUSH_SEND_PATH}`;

/*
 * Campaign history URL (GET) — neither be-admin nor be-notification serves one yet.
 * While it is unset, the Campaign page reads the history this browser stored locally.
 */
export const PUSH_HISTORY_URL = trim(process.env.REACT_APP_API_PUSH_HISTORY_URL);

// Topics the mobile app subscribes to (th-b2c-techupgrade-fe-mobile-app/src/utils/pushNotification.ts)
export const PLATFORM_TOPICS = {
  ios: "ios",
  android: "android"
};

// data.type values the mobile app handles (RootRoute.tsx -> onNotificationOpenedApp)
export const KNOWN_DATA_TYPES = ["qr_code", "allotment"];
